export default ({ services }) => roleId => {

    return roleId === services.roles.getNilRoleId();

};
